import { GET, TenantID } from "../Screens/dataSaver";
import {
  isSubscriptionModuleActive,
  isSureShieldSubscriptionActive,
  SUBSCRIPTION_APPLICATIONS,
} from "./subscriptionModules";

const TTL = 5 * 60 * 1000;

// --- General config (contract validation: vendor fields, etc.) ---

let generalConfigCache = null;
let generalConfigPending = null;
let generalConfigLastFetch = 0;

export async function fetchGeneralConfig({ force = false, ttl = TTL } = {}) {
  const now = Date.now();
  if (!force && generalConfigCache && now - generalConfigLastFetch < ttl) {
    return generalConfigCache;
  }
  if (generalConfigPending) return generalConfigPending;

  generalConfigPending = GET("entity-service/generalConfig")
    .then(({ data }) => {
      generalConfigCache = data || {};
      generalConfigLastFetch = Date.now();
      return generalConfigCache;
    })
    .finally(() => {
      generalConfigPending = null;
    });

  return generalConfigPending;
}

// --- Entity by tenant (multi-site flag, official email domain, subscriptionModules) ---

let entityCache = null;
let entityPending = null;
let entityLastFetch = 0;
let entityCacheTenantId = null;

export function getCachedEntityDetails() {
  return entityCache;
}

/** Seed/refresh the shared entity cache (e.g. from App bootstrap). */
export function setEntityDetailsCache(data, { tenantId } = {}) {
  entityCache = data || {};
  entityLastFetch = Date.now();
  if (tenantId != null) {
    entityCacheTenantId = tenantId;
  }
}

export async function fetchEntityDetails({
  tenantId,
  force = false,
  ttl = TTL,
} = {}) {
  const resolvedTenantId = tenantId || TenantID;
  const now = Date.now();
  if (
    !force &&
    entityCache &&
    now - entityLastFetch < ttl &&
    (!resolvedTenantId ||
      !entityCacheTenantId ||
      entityCacheTenantId === resolvedTenantId)
  ) {
    return entityCache;
  }
  if (entityPending) return entityPending;

  if (!resolvedTenantId) {
    throw new Error("fetchEntityDetails: tenantId is required");
  }

  entityPending = GET(`entity-service/entity/${resolvedTenantId}`)
    .then(({ data }) => {
      entityCache = data || {};
      entityLastFetch = Date.now();
      entityCacheTenantId = resolvedTenantId;
      return entityCache;
    })
    .finally(() => {
      entityPending = null;
    });

  return entityPending;
}

export async function fetchTenantSubscriptionModuleActive(
  applicationName,
  options = {}
) {
  const entity = await fetchEntityDetails(options);
  return isSubscriptionModuleActive(entity, applicationName, options);
}

export async function fetchTenantSureShieldActive(options = {}) {
  const entity = await fetchEntityDetails(options);
  return isSureShieldSubscriptionActive(entity);
}

export { SUBSCRIPTION_APPLICATIONS };
